import {useEffect} from "react";
import {useLocation} from "react-router-dom";

// In-app links swap pages without a reload, so the window would otherwise keep the previous page's scroll position.
function ScrollToTop() {
    const {key} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [key]);

    return null;
}

export default ScrollToTop;
